export default __webpack_public_path__ + "static/media/logo_MYC.15694ede.svg";